import { useMutation, useQuery } from '@tanstack/react-query'
import { instance } from '../instance'

export const useFetchServices = (filters?: Filters) => {
  const fetchAllServices = async (): Promise<FetchServicesResponse> => {
    const response = await instance.get(
      `/admin-dashboard/service?searchTerm=${filters?.searchTerm}&pageNumber=${
        filters?.pageNumber
      }&pageSize=${filters?.pageSize || 10}`,
    )
    return response.data
  }
  const queryApi = useQuery({
    queryKey: ['fetch all Roles', filters],
    queryFn: fetchAllServices,
  })
  return queryApi
}
export const useDownloadServices = (filters?: Filters) => {
  const fetchAllServices = async () => {
    const response = await instance.get(
      `/admin-dashboard/service?searchTerm=${filters?.searchTerm}&pageNumber=${
        filters?.pageNumber
      }&pageSize=${filters?.pageSize || 10}&download=true`,
      {
        responseType: 'blob',
      },
    )
    return response.data
  }
  const mutateApi = useMutation({
    mutationKey: ['fdownload all Roles', filters],
    mutationFn: fetchAllServices,
  })
  return mutateApi
}
export const useCreateNewService = () => {
  const createNewService = async (
    payload: CreateServicePayload,
  ): Promise<CreateServiceResponse> => {
    const response = await instance.post(`/admin-dashboard/service`, payload)
    return response.data
  }
  const mutateAPI = useMutation({
    mutationKey: ['Create new service'],
    mutationFn: (payload: CreateServicePayload) => createNewService(payload),
  })
  return mutateAPI
}
export const useFetchSources = (filters?: Filters) => {
  const fetchAllSources = async (): Promise<FetchSourcesResponse> => {
    const response = await instance.get(
      `/admin-dashboard/marketing-company?searchTerm=${
        filters?.searchTerm
      }&pageNumber=${filters?.pageNumber}&pageSize=${filters?.pageSize || 10}`,
    )
    return response.data
  }
  const queryApi = useQuery({
    queryKey: ['fetch all Sources', filters],
    queryFn: fetchAllSources,
  })
  return queryApi
}
export const useDownloadSources = (filters?: Filters) => {
  const fetchAllSources = async () => {
    const response = await instance.get(
      `/admin-dashboard/marketing-company?searchTerm=${
        filters?.searchTerm
      }&pageNumber=${filters?.pageNumber}&pageSize=${
        filters?.pageSize || 10
      }&download=true`,{
        responseType: 'blob',
      },
    )
    return response.data
  }
  const queryApi = useMutation({
    mutationKey: ['download all Sources', filters],
    mutationFn: fetchAllSources,
  })
  return queryApi
}
export const useCreateNewSource = () => {
  const createNewSource = async (
    payload: CreateSourcePayload,
  ): Promise<CreateSourceResponse> => {
    const response = await instance.post(
      `/admin-dashboard/marketing-company`,
      payload,
    )
    return response.data
  }
  const mutateAPI = useMutation({
    mutationKey: ['Create new source'],
    mutationFn: (payload: CreateSourcePayload) => createNewSource(payload),
  })
  return mutateAPI
}
